<script type="text/babel">
export default{
  data () {
    return {
      hidden: false
    }
  },
  mounted () {
  },
  props: [],
  computed: {
  },
  methods: {
    hideModal() {
      this.hidden = true;
    }
  }
}
</script>
